const global_variables = require('../../config');

/**
 * Blacklist arrays are set once per build/init and never mutated at runtime.
 * The config object itself is a large global that mutates (many keys change),
 * so we cache by the array references themselves, not the config object.
 */
const classRegexpsCache = new WeakMap(); // key: blacklist_classes array
const idSetCache = new WeakMap(); // key: blacklist_ids array

function escapeRegExpMatch(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

function getClassRegexp(classes) {
  let regexp = classRegexpsCache.get(classes);
  if (regexp) return regexp;
  // Single combined regex: \b(class1|class2|...)\b — one test() for all classes
  const pattern = classes.map(escapeRegExpMatch).join('|');
  regexp = new RegExp(`\\b(?:${pattern})\\b`);
  classRegexpsCache.set(classes, regexp);
  return regexp;
}

function getIdSet(ids) {
  let idSet = idSetCache.get(ids);
  if (idSet) return idSet;
  idSet = new Set(ids);
  idSetCache.set(ids, idSet);
  return idSet;
}

function node_blacklist(node, config = global_variables) {
  if (!node || typeof node.getAttribute !== 'function') {
    return false;
  }

  const classRegexp = getClassRegexp(config.blacklist_classes);
  const idSet = getIdSet(config.blacklist_ids);

  // node blacklist by class condition (single regex test — O(1) per node)
  const nodeClass = node.getAttribute('class');
  if (nodeClass && classRegexp.test(nodeClass)) {
    return true;
  }

  // node blacklist by id condition (O(1) Set lookup)
  if (idSet) {
    const nodeId = node.getAttribute('id');
    if (nodeId && idSet.has(nodeId)) {
      return true;
    }
  }

  return false;
}

module.exports = {
  node_blacklist
};
